import { createContext } from "react";
import type JsFrontendState from "./JsFrontendState";

export const FrontendStateContext = createContext<JsFrontendState>({
  domainId: undefined,
  siteId: undefined,
  siteIds: {},
  dates: {},
});
